<template>
  <div class="main-container">
    <Intro />
    <Links />
    <Navbar />
    <Projects />
    <Travels />
    <Footer />
  </div>
</template>

<script>
  import Links from '@/components/Links'
  import Intro from '@/components/Intro'
  import Projects from '@/components/Projects/'
  import Travels from '@/components/Travels'
  import Navbar from '@/components/Navbar'

  import Footer from '@/components/Footer'
  import { mapActions } from 'vuex'

  export default {
    name: 'Mrinalini',

    metaInfo: {
      title: 'Mrinalini'
    },

    data() {
      return {
        heroMinHeight: screen.height
      }
    },
    components: {
      Links,
      Navbar,
      Intro,
      Projects,
      Travels,
      Footer
    },

    methods: {
      ...mapActions(['getWindowSize']),
      handleResize() {
        const root = document.getElementsByTagName('html')[0]
        const windowSize = {
          width: root.clientWidth,
          height: root.clientHeight
        }
        this.getWindowSize(windowSize)
      }
    },

    computed: {
      opacity() {
        return this.$store.state.scrollPos
      }
    },

    mounted() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>
